import {useTranslation} from 'react-i18next';
import {ErrorScene, SceneChecklist} from 'components/ErrorScene';
import {TrustFooter} from 'components/TrustFooter';

function ReservationUnavailableView() {
  const {t} = useTranslation();

  return (
    <ErrorScene
      variant="gone"
      title={t('reservation_gone_title')}
      subtitle={t('reservation_gone_subtitle')}
      announce={t('reservation_gone_announce')}
      artClassName="lg:mt-1.5"
    >
      <SceneChecklist
        headKey="reservation_gone_checklist_head"
        rowKeys={['reservation_gone_checklist_host', 'reservation_gone_checklist_rebook']}
      />
      <TrustFooter variant="scene" />
    </ErrorScene>
  );
}

export {ReservationUnavailableView};
